var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:`${
    !_vm.$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'
  }`,attrs:{"id":"flexy"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }